export default "__VITE_ASSET__6b68f443__"